import React from 'react';
import classnames from 'classnames';

import { Width } from './types';

import './WpPageBody.scss';

export interface Props {
  children?: React.ReactNode;
  className?: string;
  width?: Width;
}

const WpPageBody: React.FC<Props> = ({ children, className, width }: Props) => {
  const baseClassName = 'WpPageBody';
  const classes = classnames(baseClassName, `${baseClassName}--${width}`, className);

  return <div className={classes}>{children}</div>;
};

export default WpPageBody;
